import { hashToSort, hashToCheckbox, hashToCompare, hashToRange, hashToText, hashToQsfv, hashToValues } from '../utilities/hash';
import * as HASH from '../constants/config/hash';

/**
 * @name createArray
 * @function
 * @description Creates a filter item array out of the hash
 * @param {string} hash Hash string
 * @returns {array} array of filter items
 */
const createArray = hash => {

    let pos = -1;

    if( hash.includes( HASH.INITIATOR ) ) pos = ( hash.indexOf( HASH.INITIATOR ) + HASH.INITIATOR.length );
    if( pos === -1 && hash.includes( HASH.INITIATOR_ALT ) ) pos = ( hash.indexOf( HASH.INITIATOR_ALT ) + HASH.INITIATOR_ALT.length );

    if( pos > -1 ) return hash.substr( pos ).split( '&' ).map(pair => decodeURIComponent(pair));

    return [];

}

/**
 * @name determineFilters
 * @function
 * @description Determines current filters applied from the hash
 * @param {array} [parameters=[]] Parameters used to determine which type of filter should be used
 * @returns {Object} 
 */
export const determineFilters = ( parameters=[] ) => {
    let hash = window.location.hash,
    hashAry = createArray( hash ),
    compare = false,
    filters = [],
    modified = [],
    sorted = [],
    selected = [],
    qs = [],
    andToggle = [],
    s3Type = null;

    for( let i = 0; i < hashAry.length; ++i ){

        let item = hashAry[ i ];
        let hashMatch = item.match(/sort=([^,]+)/),
        hashParam = hashMatch ? hashMatch[1] : null;        

        if(hashParam)
        {
            // Function to find an object containing a specific key-value pair
            const findObjectByKeyValue = (data, key, value) => {
                for (const index in data) {
                    if (data[index][key] === value) {
                        return data[index];
                    }
                }
                return null;
            };

            const foundObject = findObjectByKeyValue(parameters, 'id', hashParam);            

            if (foundObject) {
                s3Type = foundObject.s3Type;                 
            } 
        }

        // set filters
        if( HASH.PARAMETER_REGEXP.test( item ) ){

            let id = item.replace( HASH.PARAMETER_REGEXP, '$1' ),
            parameter = parameters.find( parameter => parameter.id === id ) || {};
            modified.push( id );

            // determine filters
            switch( parameter.format ){
                case 'checkbox':
                    filters.push( hashToCheckbox( item ) );
                    break;
                case 'range':
                    filters.push( hashToRange( item ) );
                    break;
                default:
                    filters.push( hashToText( item ) );
                    break;
            }
            continue;
        }
        
        // set compare
        if( HASH.COMPARE_REGEXP.test( item ) ){
            compare = true;
            selected = hashToCompare(item)
            continue;
        }
        
        // set sorted as modified
        if( HASH.SORT_REGEXP.test( item ) ){

            sorted = hashToSort( item );

            let test = sorted.map( sort => sort[ 0 ] );
            
            modified.push( ...test );
            continue;
        }

        if( HASH.QUICK_SEARCH_REGEXP.test( item ) ){
            qs = hashToQsfv( item );
            continue;
        }

        if( HASH.AND_TOGGLE_REGEXP.test( item ) ){
            andToggle = hashToValues( item );
            modified.push( ...andToggle );
            continue;
        }

    };

    return {
        compare,
        filters,
        modified,
        sorted,
        selected,
        qs,
        andToggle,
        s3Type
    };

}

/**
 * @name mapOrder
 * @function
 * @description sorts the array of object in given order array
 * @param {array} [items=[]] items array of object
 * @param {array} [order=[]] order array
 * @param {string} [key] key used to sort
 * @returns {array} 
 */
export const mapOrder = ( items = [], order=[], key='id' ) => {
    let first, second;
    items.sort(( a, b ) => {
      first = a[ key ]; second = b[ key ];
      if( order.indexOf( first ) > order.indexOf( second ) ) return 1; else return -1; 
    });
    
    return items;
  };

export const extractPSTIdFromURL = () => {
    const pathname = window.location.pathname;
    const match = pathname.match(/\/(\d+)/);

    if (match) {
      const extractedValue = match[1];
      return extractedValue;
    }

    return null; // Return null if no PST ID is found in the URL
  };

/**
 * @name getUrlParameter
 * @function
 * @description get url parameter from url
 * @param sParam
 * @param sUrl
 * @returns {string} 
 */
export const getUrlParameter = (sParam, sUrl) => {
    return sUrl.get(sParam);
};

/**
 * @name isUrlParamMatching
 * @function
 * @description get url parameter from url and validate for Filters
 * @param {string|number} parameter - The parameter to check against the URL parameters.
 * @returns {boolean} Returns true if the parameter is found in the URL parameters, false otherwise.
 */
export const isUrlParamMatching = (parameter) => {
    const urlHash = window.location.hash;
    const urlParamsMatch = urlHash.match(/p(\d+)=/g);
    const urlParams = urlParamsMatch
      ? urlParamsMatch.map((match) => match.replace('p', '').replace('=', ''))
      : [];
    
    return urlParams.includes(String(parameter));
  };